export function MenuOption(userOptions = {}, useOptionId = null) {
  // if (!useOptionId) {
  //   console.warn('no id specified... ', userOptions)
  // }

  if (!useOptionId) {
    console.warn("need to provide `id` for this MenuOption", userOptions)
  }

  return {
    id: useOptionId || createOptionId(), //Able to supply own ID for internal use
    label: "First Option",
    description: "Some text that can be shown somewhere.. if you want.",

    optionGroup: null, //"". Can be used to group dynamic options together so client can loop

    isVisible() {
      return true; //true for yes visible, false for non visible. Default: `return true`
    },

    isUnavailable() {
      return false; //CAN be cursored to, but cannot be submitted. Probably would want to gray it out.
    },

    isDisabled() {
      //Return either `false` or a String reason for `true`
      //EX: return "Not enough PP!" = yes this is disabled, and here is why

      //If truthy, arrows will skip over this one. Clicks won't work.
      //If this `isVisible` is false, automatically disable this
      return false; //A string for disabled (gets `disabledOptionClass` class)
    },

    nextView: null, //"someOtherView", //string name for next view

    handleOptionEnter() {
      //Execute this function after the user selects this Option.
      //Happens BEFORE transferring to the next view.
      //
      //default: empty. Doesn't do anything.
    },

    //Merge in user's options
    ...userOptions,

    //Now methods that can't be overwritten by the user:
    isAbleToBeSubmitted() {
      return this.isVisible() && !this.isDisabled();
    }
  };
}

/************************/

/** Generate an ID to be used by each option */
function createOptionId() {
  const prefix = "option";
  const length = 15;

  var text = "";
  var possible = "abcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < length; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return prefix + "_" + text;
}



// WEBPACK FOOTER //
// ./src/menu-engine/MenuOption.js